module.exports = __webpack_public_path__ + "img/l2.fb052488.webp";